import { DateTime, ToISOTimeOptions } from 'luxon';
import { RecurrenceRule } from '@app/calendar/recurrence-rule';

export interface ClientNote {
  client: string;
  note: string;
  session_objectives?: any[];
  is_editable?: boolean;
}

export interface Guest {
  first_name: string;
  last_name: string;
}
export interface Event {
  id?: string;
  uuid?: string;
  title?: string;
  description?: string;
  start_date_local?: DateTime;
  end_date_local?: DateTime;
  clients?: string[];
  guests?: Guest[];
  recurrence_rule?: RecurrenceRule;
  recurrence_set?: string;
  all_day?: boolean;
  location?: string;
  location_uuid?: string[];
  service_type?: string;
  hasSessionData?: boolean;
  sessions?: ClientNote[];
}

export interface ApiEvent {
  id: string;
  uuid: string;
  description: string;
  start_date?: string;
  start_date_local: string;
  timezone: string;
  end_date?: string;
  end_date_local: string;
  clients: string[];
  title: string;
  guests?: Guest[];
  recurrence_rule?: string;
  recurrence_set?: string;
  all_day?: boolean;
  location?: string;
  location_uuid?: string[];
  service_type?: string;
  has_session_data?: boolean;
  sessions?: ClientNote[];
}

export namespace ConvertEvent {
  export function fromApi(event: ApiEvent): Event {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const {
      id,
      uuid,
      description,
      location,
      location_uuid: locationUuid,
      clients,
      title,
      guests,
      sessions,
      service_type: serviceType,
      all_day: allDay,
      start_date: startDate,
      end_date: endDate,
      has_session_data: hasSessionData,
    } = event;
    return {
      id,
      uuid,
      description,
      location,
      location_uuid: locationUuid,
      all_day: allDay,
      service_type: serviceType,
      start_date_local: DateTime.fromISO(startDate),
      end_date_local: DateTime.fromISO(endDate),
      clients,
      title,
      guests,
      sessions,
      hasSessionData,
      recurrence_rule: event.recurrence_rule
        ? RecurrenceRule.parse(event.recurrence_rule)
        : null,
      recurrence_set: event.recurrence_set,
    };
  }

  const toISOTimeOptions: ToISOTimeOptions = {
    includeOffset: false,
    suppressMilliseconds: true,
    suppressSeconds: true,
  };

  export function toApi(event: Event): ApiEvent {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const {
      id,
      uuid,
      description,
      clients,
      title,
      location,
      location_uuid: locationUuid,
      service_type: serviceType,
      all_day: allDay,
      start_date_local: startDate,
      end_date_local: endDate,
    } = event;
    return {
      id,
      uuid,
      description,
      location,
      location_uuid: locationUuid,
      all_day: allDay,
      service_type: serviceType,
      start_date_local: startDate.toISO(toISOTimeOptions),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      end_date_local: endDate.toISO(toISOTimeOptions),
      clients,
      title,
      // we need null instead of undefined for un-setting the value
      recurrence_rule: event.recurrence_rule?.toString() || null,
    };
  }
}
